<template>
  <div class="card-body">
    <h4 id="header-image" class="card-title card-collapse">
      <span class="pointer" @click="onClickCollapse">Image Management</span>
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="imageComponentModel.validateState == false"
          @click="
            imageComponentModel.collapseState = !imageComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button class="btn-icon-collapse" @click="onClickCollapse">
          <template>
            <i
              v-if="imageComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-image"
      v-model="imageComponentModel.collapseState"
      @input="modelChanged"
    >
      <div class="pt-3">
        <div class="row">
          <div class="col-12">
            <div class="border-top pb-4"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card bg-dark-grey">
              <div class="card-body f-12">
                <div>รายละเอียดรูปภาพ</div>
                <ul class="mb-0">
                  <li>พื้นหลังสีขาว</li>
                  <li>
                    ไม่มี Logo หรือ Text อยู่บนรูปหลัก
                    (ยกเว้นบนกล่องหรือบนสินค้า)
                  </li>
                  <li>ใช้นามสกุล .jpg หรือ .png</li>
                  <li class="image-li">
                    dimension อย่างน้อย 800 x 800 px
                  </li>
                  <!-- <li v-else class="image-li">
                    v-if="vendor_type === 'DropShip'" 
                    dimension อย่างน้อย 2000 x 2000 px
                  </li> -->
                  <li>resolution 300 dpi</li>
                  <li>ขนาดภาพไม่เกิน 3 MB</li>
                  <li>ความกว้าง และความสูงของรูปต้องเท่ากัน</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <b-table
          ref="imageTable"
          class="line-height striped"
          head-variant="light"
          :empty-text="'ไม่พบข้อมูล'"
          :show-empty="
            imagesTable === null ||
              imagesTable === undefined ||
              (imagesTable && imagesTable.length === 0)
          "
          :striped="false"
          :bordered="true"
          v-bind:items="imagesTable"
          v-bind:fields="fields"
        >
          <template v-slot:cell(sequence)="data">
            {{ data.item.sequence }}
            <vue-easy-lightbox
              :visible="data.item.lightbox_visible"
              :imgs="data.item.images"
              :index="data.item.index_zoom"
              @hide="data.item.lightbox_visible = false"
            ></vue-easy-lightbox>
          </template>
          <template v-slot:cell(mechanic_1)="data">
            <div>
              {{
                data.value.th === data.value.en
                  ? data.value.en
                  : data.value.th + ' : ' + data.value.en
              }}
            </div>
          </template>
          <template v-slot:cell(mechanic_2)="data">
            <div>
              {{
                data.value.th === data.value.en
                  ? data.value.en
                  : data.value.th + ' : ' + data.value.en
              }}
            </div>
          </template>
          <template v-slot:cell(mechanic_3)="data">
            <div>
              {{
                data.value.th === data.value.en
                  ? data.value.en
                  : data.value.th + ' : ' + data.value.en
              }}
            </div>
          </template>
          <template v-slot:cell(mechanic_4)="data">
            <div>
              {{
                data.value.th === data.value.en
                  ? data.value.en
                  : data.value.th + ' : ' + data.value.en
              }}
            </div>
          </template>
          <template v-slot:cell(has_image)="data">
            <div>
              {{ data.value ? 'มี' : 'ส่งถ่าย' }}
            </div>
          </template>
          <template v-slot:cell(is_default_color)="data">
            <input
              type="radio"
              :name="`is_default_color_${data.item.mechanic_color}`"
              :checked="data.value"
              @click="
                onDefaultColorClick(
                  data.item.mechanic_color,
                  data.item.sku_code_ofm
                )
              "
              :disabled="
                dataPermissions.find(f => f.name === 'image_managements')
                  .isEditable === false
              "
            />
            <!-- <b-form-radio
              :name="`is_default_color_${data.item.mechanic_color}`"
              :value="data.item.sku_code_ofm"
              @input="onDefaultColorClick(data.item.mechanic_color,data.item.sku_code_ofm)"
            ></b-form-radio> -->
          </template>
          <template v-slot:cell(images)="data">
            <template v-if="data.item.images && data.item.images.length > 0">
              <span v-for="(img, index) in data.item.images" :key="index">
                <img
                  v-if="index < 4"
                  class="table-product-image"
                  :src="img.src"
                  @click="
                    data.item.index_zoom = index
                    data.item.lightbox_visible = true
                  "
                />
              </span>
              <template v-if="data.item.images.length > 4">
                {{ data.item.images.length - 1 }} +
              </template>
            </template>
            <template v-else>
              <span>- </span>
              <b-icon
                v-if="data.item.has_image"
                icon="exclamation-circle-fill"
                variant="danger"
                animation="throb"
                font-scale="2"
              ></b-icon>
            </template>
          </template>
          <template #cell(action)="row">
            <button
              :disabled="row.item.has_image === false"
              class="btn btn-sm btn-info"
              type="button"
              style="width: 80%;"
              @click="row.toggleDetails"
            >
              {{ row.detailsShowing ? 'Hide' : 'More' }}
              <i
                :class="
                  row.detailsShowing ? 'bx bx-caret-down' : 'bx bx-caret-right'
                "
                title="More Detail"
              ></i>
            </button>
          </template>
          <template #row-details="row">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">
                  #{{ row.item.sequence }}
                  <label
                    v-if="
                      dataPermissions.find(f => f.name === 'image_managements')
                        .isEditable === true && row.item.has_image
                    "
                    :for="'upload-image-' + row.item.sequence"
                    class="btn btn-success btn-sm absolute r-15-px"
                    ><i class="bx bx-plus-medical align-middle mr-1"></i> Upload
                    รูปภาพ
                  </label>
                  <input
                    type="file"
                    :id="'upload-image-' + row.item.sequence"
                    accept=".jpg, .jpeg, .png"
                    hidden
                    @change="importFileImage($event, row.item)"
                  />
                </h4>
                <div class="pt-3">
                  <div class="row">
                    <div class="col-12">
                      <div class="border-top pb-4"></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <draggable
                        v-model="row.item.images"
                        @start="dragging = true"
                        @end="dragging = false"
                        v-bind="dragOptions"
                      >
                        <transition-group
                          type="transition"
                          :name="!drag ? 'flip-list' : null"
                          class="row"
                          v-if="row.item.images && row.item.images.length > 0"
                        >
                          <div
                            class="col-sm-2 form-group image-drag"
                            v-for="(element, imageIndex) in row.item.images"
                            :key="element.sequence"
                          >
                            <img
                              class="drag-image-item"
                              :src="element.src"
                              @click="
                                row.item.index_zoom = imageIndex
                                row.item.lightbox_visible = true
                              "
                            />
                            <i
                              class="bx bx-info-circle image-info"
                              :id="
                                'image-info-' +
                                  element.sequence +
                                  '-' +
                                  row.item.sequence
                              "
                            />
                            <b-tooltip
                              :target="
                                'image-info-' +
                                  element.sequence +
                                  '-' +
                                  row.item.sequence
                              "
                              placement="right"
                              variant="info"
                              ><div v-html="getDetail(element.src)"></div
                            ></b-tooltip>
                            <button
                              v-if="
                                dataPermissions.find(
                                  f => f.name === 'image_managements'
                                ).isEditable === true
                              "
                              type="button"
                              class="btn btn-danger btn-sm image-remove"
                              @click="
                                row.item.images.splice(
                                  row.item.images.findIndex(
                                    e => e.src === element.src
                                  ),
                                  1
                                )
                              "
                            >
                              remove
                            </button>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-table>

        <!-- <table-image-management
          :skuImages="imagesTable"
          @update="onUpdateImgManagement($event)"
        /> -->
      </div>
    </b-collapse>
  </div>
</template>
<script>
// import TableImageManagement from '@/components/product-register/table-image-management'
import { eventBus } from '@/main.js'
import draggable from 'vuedraggable'
import { FormatQty } from '@/helpers/utils/format-qty.js'
import VueEasyLightbox from 'vue-easy-lightbox'
import filecloudService from '@/helpers/service/filecloud-service'

export default {
  name: 'ImageManagement',
  components: { draggable, 'vue-easy-lightbox': VueEasyLightbox },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.imageComponentModel
      },
    },
    skus: {
      type: Array,
      default: () => {
        return []
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    documentId: {
      type: String,
      default: () => {
        return ''
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      myId: '',
      imageComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: [],
      },
      permissions: [
        {
          name: 'image_managements',
          ruleIDs: ['P1', 'P4'],
          isEditable: false,
        },
      ],
      imagesTable: [],
      drag: false,
      fields: [
        {
          key: 'sequence',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: '#',
          thClass: 'w-50-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'is_default_color',
          label: 'ตัวแทนสีสินค้า',
          class: 'w-120-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'has_image',
          label: 'รูปสินค้า',
          class: 'w-120-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'images',
          label: 'ตัวอย่างรูปสินค้า',
          class: 'w-120-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'action',
          label: 'Action',
          class: 'w-120-px',
          tdClass: 'text-center',
          sortable: false,
        },
      ],
      // images_test: [
      //   {
      //     sequence: 1,
      //     title: '5010111',
      //     src:
      //       'https://aumento.officemate.co.th/media/catalog/product/5/0/5010111.jpg?imwidth=120',
      //   },
      //   {
      //     sequence: 2,
      //     title: '5010111_x2',
      //     src:
      //       'https://aumento.officemate.co.th/media/catalog/product/5/0/5010111_x2.jpg?imwidth=120',
      //   },
      //   {
      //     sequence: 3,
      //     title: '<b>5010111_x3</b>',
      //     src:
      //       'https://aumento.officemate.co.th/media/catalog/product/5/0/5010111_x3.jpg?imwidth=120',
      //   },
      //   {
      //     sequence: 4,
      //     title: 'OFM5010630',
      //     src:
      //       'https://aumento.officemate.co.th/media/catalog/product/O/F/OFM5010630.jpg?imwidth=120',
      //   },
      // ],
      lightboxVisible: false,
      mec_default_color: {},
    }
  },
  created() {
    eventBus.$on('collapse-image', text => {
      this.imageComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  async mounted() {
    this.loadTable(this.skus)
    if (!this.documentId) this.myId = '' + new Date().getTime()
    else this.myId = this.documentId
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  watch: {
    // value: {
    //   handler(val) {
    //     this.imageComponentModel = val
    //   },
    //   deep: true,
    // },
    skus: {
      handler(val) {
        this.loadTable(val)
      },
      deep: true,
    },
    imagesTable: {
      handler(val) {
        let skuImages = []
        if(val && val.length > 0) {
          val.forEach(element => {
            let _images = []
            if(element.images && element.images.length > 0) {
              element.images.forEach(img => {
              _images.push({
                sequence: img.sequence,
                size: 'original',
                url: img.src,
                //   cdn_url: img.cdn_url,
              })
            })
            }
            skuImages.push({
              sku_id: element.sku_code_ofm,
              is_default_color: element.is_default_color,
              images: _images,
            })
          })
        this.imageComponentModel.model = skuImages
        this.loadDefaultColor()
        this.$refs.imageTable.refresh()
        this.onSubmit()
        }
      },
      deep: true,
    },
    documentId() {
      if (this.documentId) this.myId = this.documentId
    },
  },
  methods: {
    modelChanged() {
      this.imageComponentModel.isPayloadChanged = true
      this.$emit('input', this.imageComponentModel)
    },
    onClickCollapse() {
      // if (this.skus && this.skus.length > 0) {
      //   this.imageComponentModel.collapseState = !this.imageComponentModel
      //     .collapseState
      // } else {
      //   setTimeout(function() {
      //     document.getElementById('collapse-product-detail').scrollIntoView({
      //       block: 'center',
      //       behavior: 'smooth',
      //     })
      //     eventBus.$emit('collapse-product-detail', true)
      //   }, 300)
      // }
      this.imageComponentModel.collapseState = !this.imageComponentModel
        .collapseState
    },
    onSubmit() {
      if (
        this.imagesTable &&
        this.imagesTable.some(
          f => f.images && f.images.length === 0 && f.has_image === true
        )
      ) {
        this.imageComponentModel.validateState = false
      } else {
        this.imageComponentModel.validateState = true
      }
      this.modelChanged()
    },
    onUpdateImgManagement(data) {
      // console.log(data)
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
    loadTable(val) {
      this.imagesTable = []
      if(val && val.length > 0) {
        val.forEach(element => {
          let exit = this.imagesTable.find(
            p => p.sku_code_ofm === element.skuModel.sku_code_ofm
          )
          if (!exit) {
            let imagesTemp = []
            let is_default_color = false
            let imageValue = this.value.model.find(
              f => f.sku_id === element.skuModel.sku_code_ofm
            )
            if (imageValue && imageValue.images.length > 0) {
              imagesTemp = imageValue.images.map((s, index) => {
                let url = s.url.split('/')
                return {
                  sequence: index + 1,
                  title: url[url.length - 1],
                  src: s.url,
                }
              })
              is_default_color = imageValue.is_default_color
            }

            let obj = {
              sequence: element.index,
              sku_code_ofm: element.skuModel.sku_code_ofm,
              product_name: element.skuModel.product_names.find(
                p => p.type === 'Document'
              ).display_name.en,
              images: imagesTemp,
              // images: this.images_test,
              index_zoom: 1,
              is_default_color: is_default_color,
              lightbox_visible: false,
              has_image: element.skuModel.other.has_image,
            }

            element.skuModel.mechanics.forEach((mec, index) => {
              if (mec.collection === 'color') {
                obj[`mechanic_color`] = mec.value.display_name.en
                this.mec_default_color[mec.value.display_name.en] = ''
              }
              obj[`mechanic_${index + 1}`] = mec.value.display_name
            })

            this.imagesTable.push(obj)
          }
        })
      }
      if (!val || val.length == 0) return

      let mechanics = val[0].skuModel.mechanics
      if (mechanics && mechanics.length > 0) {
        this.fields = [
          {
            key: 'sequence',
            formatter: (value, key, item) => {
              return FormatQty(value ? value : 0)
            },
            label: '#',
            thClass: 'w-50-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'is_default_color',
            label: 'ตัวแทนสีสินค้า',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'has_image',
            label: 'รูปสินค้า',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'images',
            label: 'ตัวอย่างรูปสินค้า',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'action',
            label: 'Action',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
        ]
        if(mechanics && mechanics.length > 0){
          mechanics.forEach((element, index) => {
            this.fields.splice(index + 1, 0, {
              key: `mechanic_${index + 1}`,
              label: element.display_name.th,
              tdClass: 'text-center',
              sortable: false,
            })
          })
        }
      } else {
        this.fields = [
          {
            key: 'sequence',
            formatter: (value, key, item) => {
              return FormatQty(value ? value : 0)
            },
            label: '#',
            thClass: 'w-50-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'is_default_color',
            label: 'ตัวแทนสีสินค้า',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'has_image',
            label: 'รูปสินค้า',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'images',
            label: 'ตัวอย่างรูปสินค้า',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
          {
            key: 'action',
            label: 'Action',
            class: 'w-120-px',
            tdClass: 'text-center',
            sortable: false,
          },
        ]
      }
    },
    getDetail(src) {
      let img = new Image()
      img.src = src
      return `

      <div class="text-left"><label class="w-90-px mb-0">Item Type:</label><span>${img.src
        .split(/[#?]/)[0]
        .split('.')
        .pop()
        .trim()}</span></div>
      <div class="text-left"><label class="w-90-px mb-0">Size:</label><span>${'original'}</span></div>
      <div class="text-left" style="display: inline-block; width: max-content;"><label class="w-90-px mb-0">Dimensions:</label><span>${
        img.width
      }px x ${img.height}px</span></div>
      <div class="text-left"><label class="w-90-px mb-0">Width:</label><span>${
        img.width
      }px</span></div>
      <div class="text-left"><label class="w-90-px mb-0">Height:</label><span>${
        img.height
      }px</span></div>`
    },
    async importFileImage(e, row) {
      let vm = this
      const file = e.target.files[0]
      console.log('file', file)
      if (file) {
        if (file.size > 35000000) {
          //around 3mb
          vm.$utils.notification('error', 'ขนาดไฟล์ไม่เหมาะสม', 2000)
        } else {
          if (file.type.match(/image.*/)) {
            let reader = new FileReader()
            reader.onload = async function(readerEvent) {
              let image = new Image()
              image.onload = async function(imageEvent) {
                // if (vm.vendor_type === 'DropShip') {
                if (
                  Number(image.height) >= 800 &&
                  Number(image.width) >= 800 &&
                  Number(image.height) == Number(image.width)
                ) {
                  await vm.uploadImage(file, row)
                } else {
                  vm.$utils.notificationAck(
                    'error',
                    `ขนาดรูปไม่เหมาะสม (${Number(image.height)} x ${Number(
                      image.width
                    )})`
                  )
                }
                // }
                // else {
                //   if (
                //     Number(image.height) >= 2000 &&
                //     Number(image.width) >= 2000 &&
                //     Number(image.height) == Number(image.width)
                //   ) {
                //     await vm.uploadImage(file, row)
                //   } else {
                //     vm.$utils.notificationAck(
                //       'error',
                //       `ขนาดรูปไม่เหมาะสม (${Number(image.height)} x ${Number(
                //         image.width
                //       )})`
                //     )
                //   }
                // }
              }
              image.src = readerEvent.target.result
            }
            reader.readAsDataURL(file)
          }
        }
      }
    },
    async uploadImage(file, row) {
      let sp = file.name.split('.')
      let extension = `.${sp[sp.length - 1]}`
      let _fname = file.name.replace(extension, '')
      // console.log('_fname', _fname)
      // console.log('extension', extension)
      let fileName = `${this.toSeoUrl(_fname)}${extension}`
      let dataOriginal = new FormData()
      dataOriginal.append('file', file, fileName)
      dataOriginal.append('bucket', `${process.env.VUE_APP_BUCKET_PIM}`)
      dataOriginal.append(
        'path',
        `tmp/register/sku_images/${this.myId}/${row.sequence}/${row.images.length}`.toLowerCase()
      )
      dataOriginal.append('key', fileName)
      dataOriginal.append('content_description', `pim-register-sku-images`)
      dataOriginal.append('is_upsert', true)
      dataOriginal.append('content_tags','[]')
      let resultUploadOriginal = await filecloudService.uploadImageAsync(
        dataOriginal
      )
      eventBus.$emit('changeLoadingState', false)
      if (resultUploadOriginal.status === 201) {
        row.images.push({
          sequence: row.images.length + 1,
          title: fileName,
          src: resultUploadOriginal.data.content_url,
          //  cdn_url: resultUploadOriginal.data.content_cdn_url,
        })
        // if (fileDoctype === 'document') {
        //   this.documentComponentModel.fileDocuments.push({
        //     sequence: this.documentComponentModel.fileDocuments.length + 1,
        //     file: { size: file.size, name: fileName, type: file.type },
        //     createOn: new Date(),
        //     flag: 'new',
        //     documentType: 'Document',
        //     url: resultUploadOriginal.data.content_url,
        //   })
        // } else if (fileDoctype === 'video') {
        //   this.documentComponentModel.fileDocuments.push({
        //     sequence: this.documentComponentModel.fileDocuments.length + 1,
        //     file: { size: file.size, name: fileName, type: file.type },
        //     createOn: new Date(),
        //     flag: 'new',
        //     documentType: 'Video',
        //     url: resultUploadOriginal.data.content_url,
        //   })
        // }
      } else {
        this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload ไฟล์')
      }
    },
    toSeoUrl(url) {
      // make the url lowercase
      let encodedUrl = url.toString().toLowerCase()

      // replace & with and
      encodedUrl = encodedUrl
        .split(/\&+/) /* eslint-disable-line */
        .join('-and-') /* eslint-disable-line */

      // remove invalid characters
      encodedUrl = encodedUrl
        .split(/[^a-z0-9]/) /* eslint-disable-line */
        .join('-') /* eslint-disable-line */

      // remove duplicates
      encodedUrl = encodedUrl.split(/-+/).join('-') /* eslint-disable-line */

      // trim leading & trailing characters
      encodedUrl = encodedUrl.trim('-')

      return encodedUrl
    },
    onDefaultColorClick(model, val) {
      this.$set(this.mec_default_color, `${model}`, `${val}`)
      this.loadDefaultColor()
    },
    loadDefaultColor() {
      for (let [index, element] of this.imageComponentModel.model.entries()) {
        let isSet = false
        for (let key in this.mec_default_color) {
          if (element.sku_id === this.mec_default_color[key]) {
            element.is_default_color = true
            isSet = true
          }
        }
        if (
          this.imagesTable.find(f => f.sku_code_ofm === element.sku_id)
            .is_default_color
        ) {
          element.is_default_color = true
        } else if (!isSet) element.is_default_color = false
      }
    },
  },
}
</script>
<style>
.drag-image-item {
  width: 100%;
  padding: 10px;
  border: 4px dashed #efefef;
  cursor: grab;
}
.upload-box {
  width: 100%;
  padding: 10px;
  border: 4px dashed #efefef;
}
.image-info {
  padding: 2px;
  cursor: pointer;
  position: absolute;
  top: 7px;
  left: 19px;
  font-size: 18px;
  color: #c4c4c4;
}
.image-remove {
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  right: 22px;
  padding: 2px 6px;
  font-size: 8px;
  /* color: #c4c4c4; */
  opacity: 0;
  transition: 0.3s;
}
.image-drag {
  position: relative;
}
.image-drag:hover > .image-remove {
  opacity: 1;
}
</style>
